"use strict"

///TESTING FOR BRANCH////
//////////////////////////

function blinkElement(element) {
    element.delay(100).fadeOut().fadeIn('slow')
}

function objToUrlParam(obj) {
    let s = Object.keys(obj).map(function (key) {
        return key + '=' + obj[key];
    }).join('&');

    return s;
}

function blockUi(element, message = "Loading...") {
    KApp.block(element, {
        overlayColor: "#000000",
        opacity: 0,
        type: "v2",
        state: "brand",
        message: message
    });
}

function blockUiNoSpinner(element, message = "Loading...", _size = 'lg') {
    KApp.blocknospinner(element, {
        overlayColor: "#000000",
        type: "v2",
        state: "brand",
        message: message,
        size: _size
    });
}

function unBlockUi(element) {
    KApp.unblock(element);
}

function openInNewtab(element, modulecode = "", restrictioncode = "") {
    $.post(
        urlSetter.replace('Action', 'user-checkrestriction').replace('Controller', 'useraccess').replace('Controller', 'framework'),
        {
            modulecode: modulecode,
            restrictioncode: restrictioncode
        },
        function (response) {

            if (response.access === true) {
                window.open(urlSetter.replace('Action', action).replace('Controller', controller), '_blank');
            } else {
                swal(
                    'System Warning',
                    response.message,
                    'warning'
                );
            }
        }
    );
}

function openLink(action = '', controller = '', area = '', modulecode = '', restrictioncode = '') {
    $('#divLoadPage').fadeIn('slow', function () {

        if (modulecode !== "" && restrictioncode !== "") {
            $.post(
                urlSetter.replace('Action', 'user-checkrestriction').replace('Controller', 'useraccess').replace('Area', 'framework'),
                {
                    modulecode: modulecode,
                    restrictioncode: restrictioncode
                },
                function (response) {

                    if (response.access === true) {
                        if (area[0].toUpperCase() === area[0]) {
                            window.location.replace(`/${area}/${controller}/${action}`);
                        } else {
                            window.location.replace(urlSetter.replace('Action', action).replace('Controller', controller).replace('Area', area));
                        }
                    } else {
                        swal(
                            'Restricted Access',
                            response.message,
                            'warning'
                        );
                        $('#divLoadPage').fadeOut();
                    }
                }
            );
        } else {
            if (area[0].toUpperCase() === area[0]) {
                window.location.replace(`/${area}/${controller}/${action}`);
            } else {
                window.location.replace(urlSetter.replace('Action', action).replace('Controller', controller).replace('Area', area));
            }
        }

    });

}

function getUrlParam(parameter, defaultvalue) {
    let urlparameter = defaultvalue;
    if (window.location.href.indexOf(parameter) > -1) {
        urlparameter = getUrlVars()[parameter];
    }
    return urlparameter;
}

function getUrlVars() {
    let vars = {};
    let parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
    });
    return vars;
}

function setTabIndexes() {
    // On the open of Modal window
    //Updating the tabindex value to another attribute and make the tabindex =-1 which is the background
    $(document).on('open', '.remodal', function () {
        $('input').attr('tabindex', "-1");
        $('.modal-form input').each(function (index, input) {
            input.tabIndex = index + 1;
        });
    });

    $(document).on('close', '.remodal', function () {
        $('input').each(function (index, input) {
            input.tabIndex = index + 1;
        });
    });
}

$.validator.addMethod('notEarlyThanDateToday', function (value, element, params) {
    // if end date is valid, validate it as well
    let end = $(params);
    let dateNow = moment().format('MM/DD/YYYY');
    if (!end.data('validation.running')) {
        $(element).data('validation.running', true);
        // The validator internally keeps track of which element is being validated currently.  This ensures that validating 'end' will not trample 'start'
        // see http://stackoverflow.com/questions/22107742/jquery-validation-date-range-issue
        setTimeout($.proxy(

            function () {
                this.element(end);
            }, this), 0);
        // Ensure clearing the 'flag' happens after the validation of 'end' to prevent endless looping
        setTimeout(function () {
            $(element).data('validation.running', false);
        }, 0);
    }
    return this.optional(element) || this.optional(end[0]) || moment(value).isAfter(moment(dateNow)) || moment(value).isSame(moment(dateNow));
}, 'Must not be before date today');

$.validator.addMethod('notEarlyThanDateFrom', function (value, element, params) {
    // if start date is valid, validate it as well
    let start = $(params);
    if (!start.data('validation.running')) {
        $(element).data('validation.running', true);
        setTimeout($.proxy(

            function () {
                this.element(start);
            }, this), 0);
        setTimeout(function () {
            $(element).data('validation.running', false);
        }, 0);
    }
    return this.optional(element) || this.optional(start[0]) || moment(value).isAfter(moment(start.val()));
}, 'Must be after corresponding start date');

$.validator.addMethod('notMoreThanDate', function (value, element, params) {
    let dateToBeCompared = params[0];
    let days = params[1];
    let targetMaxDate = moment(dateToBeCompared).add(days, 'd').format('MM/DD/YYYY');
    return moment(value).isBefore(moment(targetMaxDate)) || moment(value).isSame(moment(targetMaxDate));
}, 'Must not be more than date compared');

$.validator.addMethod('interveningPeriod', function (value, element, params) {
    let interveningPeriodFrom = $(params).val();
    let interveningPeriodTo = value;
    return this.optional(element) || interveningPeriodTo <= 90 && interveningPeriodFrom >= 0;
}, 'Intervening Period should range from 0 day up to 90 days only.');

// Add Custom Date Range Validation 
$.validator.addMethod('daterange', function (value, element, parameter) {
    if (this.optional(element)) {
        return true;
    }
    let startDate = Date.parse('01/01/1900'),
        endDate = Date.parse(new Date()),
        enteredDate = Date.parse(value);
    return ((startDate <= enteredDate) && (enteredDate <= endDate));
}, "Please specify a valid date.");

function htmlEntities(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

// amountOptional
$.validator.addMethod("amountOptional", function (value, element, params) {
    element = $(element);
    if (element.val() !== "" && parseFloat(element.val()) !== 0.00) {
        let valid = false;
        value = parseFloat(value);
        if (value >= params[0] && value <= params[1]) {
            valid = true;
        }
        return valid;
    } else {
        return true;
    }
}, "Please enter an amount between {0} and {1}");

$.validator.addMethod('filesize', function (value, element, param) {
    // param = size (en bytes) 
    // element = element to validate (<input>)
    // value = value of the element (file name)
    return this.optional(element || element.files[0].size <= param);
}, 'File exceeded upload limit.');

$.validator.addMethod("notEqualTo", function (value, element, param) {
    let notEqual = true;
    value = $.trim(value);

    if (param instanceof Array) {
        for (i = 0; i < param.length; i++) {
            if (value === $.trim($(param[i]).val())) {
                notEqual = false;
            }
        }
    }
    else if (typeof param == "function") {
        let compareValueWith = param();
        if (compareValueWith.toUpperCase() === value.toUpperCase()) {
            notEqual = false;
        }
    }
    else if (typeof param == "string") {
        if (value.toUpperCase() === $.trim(param).toUpperCase()) {
            notEqual = false;
        }
    }
    else {
        if (value.toUpperCase() === $.trim($(param).val()).toUpperCase()) {
            notEqual = false;
        }
    }

    return this.optional(element) || notEqual;
}, "Please enter a different value.");

$.validator.addMethod("sameWith", function (value, element, param) {
    let same = true;
    value = $.trim(value);

    //if (param instanceof Array) {
    //    for (i = 0; i < param.length; i++) {
    //        if (value !== $.trim($(param[i]).val())) {
    //            same = false;
    //        }
    //    }
    //}
    //else if (typeof param == "function") {
    //    let compareValueWith = param();
    //    if (compareValueWith !== value) {
    //        same = false;
    //    }
    //}
    //else if (typeof param == "string") {
    //    if (value !== $.trim(param)) {
    //        same = false;
    //    }
    //}
    //else {
    //    if (value !== $.trim($(param).val())) {
    //        same = false;
    //    }
    //}

    if (value !== $.trim(param)) {
        same = false;
    }

    //return this.optional(element) || same;
    return same;
}, "Please enter a different value.");

$.validator.addMethod('uwFrom', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value2 > value1;
}, 'Please specify Underweight From lesser than Underweight To');

$.validator.addMethod('uwTo', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value1 > value2;
}, 'Please specify Underweight To greater than Underweight From');

$.validator.addMethod('uwFromVSnFrom', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value2 > value1;
}, 'Please specify Underweight From lesser than the Normal weight');

$.validator.addMethod('uwFromVSowFrom', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value2 > value1;
}, 'Please specify Underweight From lesser than the Overweight');

$.validator.addMethod('uwFromVSobese', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value2 > value1;
}, 'Please specify Underweight From lesser than the Obese weight');

$.validator.addMethod('nFrom', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value2 > value1;
}, 'Please specify Normal From lesser than Normal To');

$.validator.addMethod('nTo', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value1 > value2;
}, 'Please specify Normal To greater than Normal From');

$.validator.addMethod('nFromVSuwFrom', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value2 < value1;
}, 'Please specify Normal Weight From greater than the Underweight');

$.validator.addMethod('nFromVSowFrom', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value2 > value1;
}, 'Please specify Normal Weight From lesser than the Overweight');

$.validator.addMethod('nFromVSobese', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value2 > value1;
}, 'Please specify Normal Weight From lesser than the Obese weight');

$.validator.addMethod('owFrom', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value2 > value1;
}, 'Please specify Overweight From lesser than Overweight To');

$.validator.addMethod('owTo', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value1 > value2;
}, 'Please specify Overweight To greater than Overweight From');

$.validator.addMethod('owFromVSuwTo', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value2 < value1;
}, 'Please specify Overweight From greater than the Underweight');

$.validator.addMethod('owFromVSnTo', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value2 < value1;
}, 'Please specify Overweight From greater than the Normal weight');

$.validator.addMethod('owFromVSobese', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value2 > value1;
}, 'Please specify Overweight From lesser than the Obese weight');

$.validator.addMethod('obeseVSuwTo', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value2 < value1;
}, 'Please specify Obese weight greater than the Underweight');

$.validator.addMethod('obeseVSnTo', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value2 < value1;
}, 'Please specify Obese weight greater than the Normal weight');

$.validator.addMethod('obeseVSowTo', function (value, element, param) {
    let value1 = parseFloat(value);
    let value2 = parseFloat($(param).val());

    return this.optional(element) || value2 < value1;
}, 'Please specify Obese weight greater than the Overweight');

$.validator.addMethod('minimumCoverage', function (value, element, param) {
    let minimumCoverage = value === '' ? 0 : parseFloat(value.replace(',', ''));
    let maximumCoverage = parseFloat($(param).val().replace(',', ''));
    let equalToZero = false;

    if (minimumCoverage === 0 && maximumCoverage === 0) {
        equalToZero = true;
    } else {
        equalToZero = false;
    }

    return this.optional(element) || maximumCoverage > minimumCoverage || equalToZero;
}, 'Minimum Coverage should not exceed Maximum Coverage.');

$.validator.addMethod('maximumCoverage', function (value, element, param) {
    let maximumCoverage = value === '' ? 0 : parseFloat(value.replace(',', ''));
    let minimumCoverage = parseFloat($(param).val().replace(',', ''));
    let equalToZero = false;

    if (minimumCoverage === 0 && maximumCoverage === 0) {
        equalToZero = true;
    } else {
        equalToZero = false;
    }

    return this.optional(element) || minimumCoverage < maximumCoverage || equalToZero;
}, 'Maximum Coverage should not be less than Minimum Coverage.');

$.validator.addMethod('nmlAmount', function (value, element, param) {
    let nelAmount = parseFloat($(param).val().replace(',', ''));
    let nmlAmount = parseFloat(value.replace(',', ''));
    let equalToZero = false;

    if (nmlAmount === 0) {
        equalToZero = true;
    } else {
        equalToZero = false;
    }

    return this.optional(element) || nmlAmount > nelAmount || equalToZero;
}, 'NML Amount must be larger than NEL Amount.')

$.validator.addMethod('ageFrom', function (value, element, param) {
    let ageFromPrin = value === '' ? 0 : parseInt(value);
    let ageToPrin = parseInt($(param).val());
    let equalToZero = true;

    if (ageFromPrin === 0 && ageToPrin === 0) {
        equalToZero = true;
    } else {
        equalToZero = false;
    }

    return this.optional(element) || ageFromPrin < ageToPrin || equalToZero;
}, 'Invalid Age Range (Age From)');

$.validator.addMethod('ageTo', function (value, element, param) {
    let ageToPrin = value === '' ? 0 : parseInt(value);
    let ageFromPrin = parseInt($(param).val());
    let equalToZero = true;

    if (ageFromPrin === 0 && ageToPrin === 0) {
        equalToZero = true;
    } else {
        equalToZero = false;
    }

    return this.optional(element) || ageToPrin > ageFromPrin || equalToZero;
}, 'Invalid Age Range (Age To)');

$.validator.addMethod('ageFromTerm', function (value, element, param) {
    let ageFrom = 0;
    let ageTo = 0;
    let paramAgeTo = param[0];
    let paramAgeFromTerm = param[1];
    let paramAgeToTerm = param[2];
    let paramDayFrom = param[3];
    let ageEqualToZero = false;

    let fromMultiplier = 0;
    switch (parseInt(paramAgeFromTerm.val())) {
        case 1: fromMultiplier = 1; break;
        case 2: fromMultiplier = 7; break;
        case 3: fromMultiplier = 31; break;
        case 4: fromMultiplier = 365; break;
    }

    let toMultiplier = 0;
    switch (parseInt(paramAgeToTerm.val())) {
        case 1: toMultiplier = 1; break;
        case 2: toMultiplier = 7; break;
        case 3: toMultiplier = 31; break;
        case 4: toMultiplier = 365; break;
    }

    if (parseInt(paramAgeFromTerm.val()) === 1) {
        value = value === '' ? 0 : parseInt(value);
        ageFrom = value
    } else {
        value = value === '' ? 0 : parseInt(value);
        ageFrom = value * fromMultiplier;
    }

    if (parseInt(paramAgeToTerm.val()) === 1) {
        ageTo = parseInt(paramAgeTo.val());
    } else {
        ageTo = parseInt(paramAgeTo.val()) * toMultiplier;
    }

    if (ageFrom === 0 && ageTo === 0) {
        ageEqualToZero = true;
    } else {
        ageEqualToZero = false;
    }

    paramDayFrom.val(ageFrom);

    return this.optional(element) || ageTo > ageFrom || ageFrom < ageTo || ageEqualToZero;
}, 'Invalid Age Range (Age From)');

$.validator.addMethod('ageToTerm', function (value, element, param) {
    let ageFrom = 0;
    let ageTo = 0;
    let paramAgeFrom = param[0];
    let paramAgeFromTerm = param[1];
    let paramAgeToTerm = param[2];
    let paramDayTo = param[3];
    let ageEqualToZero = false;

    let fromMultiplier = 0;
    switch (parseInt(paramAgeFromTerm.val())) {
        case 1: fromMultiplier = 1; break;
        case 2: fromMultiplier = 7; break;
        case 3: fromMultiplier = 31; break;
        case 4: fromMultiplier = 365; break;
    }

    let toMultiplier = 0;
    switch (parseInt(paramAgeToTerm.val())) {
        case 1: toMultiplier = 1; break;
        case 2: toMultiplier = 7; break;
        case 3: toMultiplier = 31; break;
        case 4: toMultiplier = 365; break;
    }

    if (parseInt(paramAgeFromTerm.val()) === 1) {
        ageFrom = parseInt(paramAgeFrom.val());
    } else {
        ageFrom = parseInt(paramAgeFrom.val()) * fromMultiplier;
    }

    if (parseInt(paramAgeToTerm.val()) === 1) {
        value = value === '' ? 0 : parseInt(value);
        ageTo = value
    } else {
        value = value === '' ? 0 : parseInt(value);
        ageTo = value * toMultiplier;
    }

    if (ageFrom === 0 && ageTo === 0) {
        ageEqualToZero = true;
    } else {
        ageEqualToZero = false;
    }

    paramDayTo.val(ageTo);

    return this.optional(element) || ageFrom < ageTo || ageTo > ageFrom || ageEqualToZero;
}, 'Invalid Age Range (Age To)');

$.validator.addMethod('valueNotEqualTo', function (value, element, param) {
    return this.optional(element) || param !== value;
}, 'Please specify the Parameter')

$.validator.addMethod("isObjectNull", function (value, element, param) {

    if (param) {
        return true;
    }
    else {
        return false;
    }

}, "Object is null")

$.validator.addMethod("custom", function (value, element, param) {

    if (param) {
        return true;
    }
    else {
        return false;
    }

}, "")

$.validator.addMethod('greaterThan', function (value, el, param) {
    return value > param;
}, "");

// Return true if form has changed, else false.
$.fn.extend({
    trackChanges: function () {
        $(":input", this).on('input', function () {
            $(this.form).attr("data-changed", true);
        });

        $(".selectpicker", this).on('changed.bs.select', function () {
            $(this.form).attr("data-changed", true);
        });
    }
    ,
    isChanged: function () {
        return this.attr("data-changed") === 'true' ? true : false;
    }
});

$.fn.extend({
    animateCss: function (animationName, callback) {
        let animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        this.addClass('animated ' + animationName).one(animationEnd, function () {
            let element = $(this);
            element.removeClass('animated ' + animationName);
            if (callback && typeof callback === 'function') callback(element);
        });
    }
});

$.fn.putCursorAtEnd = function () {
    return this.each(function () {
        // Cache references
        let $el = $(this),
            el = this;

        // Only focus if input isn't already
        if (!$el.is(":focus")) {
            $el.focus();
        }
        // If this function exists... (IE 9+)
        if (el.setSelectionRange) {

            // Double the length because Opera is inconsistent about whether a carriage return is one character or two.
            let len = $el.val().length * 2;

            // Timeout seems to be required for Blink
            setTimeout(function () {
                el.setSelectionRange(len, len);
            }, 1);

        } else {
            // As a fallback, replace the contents with itself
            // Doesn't work in Chrome, but Chrome supports setSelectionRange
            $el.val($el.val());
        }

        // Scroll to the bottom, in case we're in a tall textarea
        // (Necessary for Firefox and Chrome)
        this.scrollTop = 999999;
    });
};

$.fn.isOnScreen = function (partial) {

    //let's be sure we're checking only one element (in case function is called on set)
    var t = $(this).first();

    //we're using getBoundingClientRect to get position of element relative to viewport
    //so we dont need to care about scroll position
    var box = t[0].getBoundingClientRect();

    //let's save window size
    var win = {
        h: $(window).height(),
        w: $(window).width()
    };

    //now we check against edges of element

    //firstly we check one axis
    //for example we check if left edge of element is between left and right edge of scree (still might be above/below)
    var topEdgeInRange = box.top >= 0 && box.top <= win.h;
    var bottomEdgeInRange = box.bottom >= 0 && box.bottom <= win.h;

    var leftEdgeInRange = box.left >= 0 && box.left <= win.w;
    var rightEdgeInRange = box.right >= 0 && box.right <= win.w;


    //here we check if element is bigger then window and 'covers' the screen in given axis
    var coverScreenHorizontally = box.left <= 0 && box.right >= win.w;
    var coverScreenVertically = box.top <= 0 && box.bottom >= win.h;

    //now we check 2nd axis
    var topEdgeInScreen = topEdgeInRange && (leftEdgeInRange || rightEdgeInRange || coverScreenHorizontally);
    var bottomEdgeInScreen = bottomEdgeInRange && (leftEdgeInRange || rightEdgeInRange || coverScreenHorizontally);

    var leftEdgeInScreen = leftEdgeInRange && (topEdgeInRange || bottomEdgeInRange || coverScreenVertically);
    var rightEdgeInScreen = rightEdgeInRange && (topEdgeInRange || bottomEdgeInRange || coverScreenVertically);

    //now knowing presence of each edge on screen, we check if element is partially or entirely present on screen
    var isPartiallyOnScreen = topEdgeInScreen || bottomEdgeInScreen || leftEdgeInScreen || rightEdgeInScreen;
    var isEntirelyOnScreen = topEdgeInScreen && bottomEdgeInScreen && leftEdgeInScreen && rightEdgeInScreen;

    return partial ? isPartiallyOnScreen : isEntirelyOnScreen;

};

$.expr.filters.onscreen = function (elem) {
    return $(elem).isOnScreen(true);
};

$.expr.filters.entireonscreen = function (elem) {
    return $(elem).isOnScreen(false);
};

function deepClone(initalObj, finalObj) {
    let obj = finalObj || {};
    for (let i in initalObj) {
        let prop = initalObj[i];
        // Avoid infinite loop
        if (prop === obj) {
            continue;
        }

        if (typeof prop === 'object') {
            if (prop === null) {
                obj[i] = prop;
            } else {
                obj[i] = (prop.constructor === Array) ? [] : {};
                deepClone(prop, obj[i]);
            }
        } else {
            obj[i] = prop;
        }
    }
    return obj;
}

function ResetQueryContainer(QueryContainer) {
    QueryContainer.find('input[type=text]').val("");
    QueryContainer.find('input[type=hidden]').val("0");
    QueryContainer.find('select.bootstrap-select').each(function (i, el) {
        $(el).val($(el).find('option:first').val()).change();
    });

}

function initMap(anchorEl = $(), center = { lat: 0.00, long: 0.00 }, zoom = 8) {
    center.lat = Number(center.lat);
    center.long = Number(center.long);

    let map = new google.maps.Map($(anchorEl)[0], {
        center: new google.maps.LatLng(center.lat, center.long),
        zoom: zoom
    });

    let marker = new google.maps.Marker({
        position: new google.maps.LatLng(center.lat, center.long),
        map: map
    });
}

function initLeafletMap(map = null, anchorEl = $(), center = { lat: 0.00, long: 0.00 }, zoom = 8) {
    center.lat = Number(center.lat);
    center.long = Number(center.long);

    map = L.map($(anchorEl)[0], {
        center: L.latLng(center.lat, center.long),
        zoom: zoom
    });

    let provider = L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributor'
    });

    let marker = L.marker(L.latLng(center.lat, center.long));

    provider.addTo(map);
    marker.addTo(map);

    return map;
}

function initEmbeddedGMap(anchorEl = $(), providername = '') {
    let uri = `https://maps.google.com/maps?q=providername&t=&z=14&ie=UTF8&iwloc=&output=embed`;
    uri = encodeURI(uri.replace('providername', providername));
    anchorEl.html(`
        <div class="mapouter">
           <div class="gmap_canvas">
              <iframe class="w-100" id="gmap_canvas" src="${uri}" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" style="height: 45vh;">
              </iframe>
           </div>
        </div>
    `);
}

//function initEmbeddedGMapAddress(anchorEl = $(), provideraddress = '') {
//    let uri = `https://maps.google.com/maps?q=provideraddress&t=&z=30&ie=UTF8&iwloc=&output=embed`;
//    anchorEl.html(`
//        <div class="mapouter">
//           <div class="gmap_canvas">
//              <iframe class="w-100" id="gmap_canvas" src="${encodeURI(uri.replace('provideraddress', provideraddress))}" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" style="height: 45vh;">
//              </iframe>
//           </div>
//        </div>
//    `);
//}

navigator.sendBeacon = navigator.sendBeacon || function (url, data) {
    let client = new XMLHttpRequest();
    client.open("POST", url, false);
    client.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
    client.send(data);
};

function getBase64(file) {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

function convertToObject(serializeForm = '') {
    let data = serializeForm.split("&");
    let obj = {};
    for (let key in data) {
        obj[data[key].split("=")[0]] = data[key].split("=")[1];
    }
    return obj;
}

function toggleShowPassword(btn, input) {
    $(btn).css('visibility', 'hidden');
    $(btn).attr('disabled', true);

    $(input).parent()
        .on('focus mouseenter', function (e) {
            $(btn).css('visibility', 'visible');
            $(btn).attr('disabled', false);
        })
        .on('mouseleave', function (e) {
            $(btn).css('visibility', 'hidden');
            $(btn).attr('disabled', true);
        });

    $(btn)
        .off('click')
        .on('click', function (e) {
            if ($(input).attr('type') === "password") {
                $(input).attr('type', 'text');
                $(btn).html('<i class="la la-eye-slash" style="font-size:1.2rem;"></i>');
                $(btn).attr('data-original-title', "Hide Password");
                $(btn).addClass('show');
            }
            else {
                $(input).attr('type', 'password');
                $(btn).html('<i class="la la-eye" style="font-size:1.2rem;"></i>');
                $(btn).attr('data-original-title', "Show Password");
                $(btn).removeClass('show');

            }
        });
}

function toggleClearInput(btn, input, hiddenInput) {
    $(btn).css('visibility', 'hidden');
    $(btn).attr('disabled', true);

    $(input).parent()
        .on('focus mouseenter', function (e) {
            $(btn).css('visibility', 'visible');
            $(btn).attr('disabled', false);
        })
        .on('mouseleave', function (e) {
            $(btn).css('visibility', 'hidden');
            $(btn).attr('disabled', true);
        });

    $(btn)
        .off('click')
        .on('click', function (e) {



        });
}

function initDatatable(dtContainer) {
    blockUi($(dtContainer));
    try {
        let _datatable = $(dtContainer).KDatatable();
        _datatable.destroy();
        $(dtContainer).prop('isKDatatable', false);
        datatable();
    }
    catch (err) {
        datatable();
    }
    unBlockUi($(dtContainer));
}

function debugError(errMsg) {

    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-top-center",
        "preventDuplicates": true,
        "onclick": null,
        "showDuration": "1500",
        "hideDuration": "1000",
        "timeOut": "0",
        "extendedTimeOut": "0",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };

    console.error(errMsg);
}

function toastrError(errMsg) {

    let _timeOut = "7000";

    toastr.options = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-top-center",
        "preventDuplicates": true,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": _timeOut,
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };

    toastr.error(errMsg);
}

function toastrWarning(errMsg, hideduration = 1000, title = "") {

    let _timeOut = "7000";
    //toastr.remove();

    toastr.options = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-top-center",
        "preventDuplicates": true,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": hideduration,
        "timeOut": _timeOut,
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut",
    };

    toastr.warning(title, errMsg);
}

function toastrInfo(errMsg) {

    //toastr.remove();
    let _timeOut = "7000";

    toastr.options = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-top-center",
        "preventDuplicates": true,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": _timeOut,
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };

    toastr.info(errMsg);
}

function toastrSuccess(msg) {
    let _timeOut = "7000";

    toastr.options = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-top-center",
        "preventDuplicates": true,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": _timeOut,
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };

    toastr.success(msg);
}

function toastrError_NoAutoHide(errMsg) {

    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-bottom-center",
        "preventDuplicates": true,
        "onclick": null,
        "showDuration": "1500",
        "hideDuration": "1000",
        "timeOut": "0",
        "extendedTimeOut": "0",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };

    toastr.error(errMsg);
}

function toastrInfo_NoAutoHide(msg) {

    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": true,
        "progressBar": false,
        "positionClass": "toast-top-right",
        "preventDuplicates": true,
        "onclick": null,
        "showDuration": "1500",
        "hideDuration": "1000",
        "timeOut": "0",
        "extendedTimeOut": "0",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };

    toastr.info(msg);
}

function clearQuickSearch(container) {
    container.find('.quick-search').attr("disabled", false);
    container.find('.btn-remove-search').attr("disabled", false);
}

let formUtil = {
    massConvertFormatToCurrency: function (obj, arrCurrencyProperty) {

        for (let prop of arrCurrencyProperty) {
            if (obj.hasOwnProperty(prop)) {
                obj[prop] = formatToCurrency(obj[prop]);
            }
        }

        return obj;
    },
    resetSaveForm: function (saveForm, _validated) {

        //console.log('resetting');
        saveForm.trigger('reset');
        saveForm.find('input[type=hidden]').val('0');
        saveForm.find('input[type=text]').val('');
        saveForm.find('textarea').val("");
        saveForm.find('input[type=radio]:not([value="No"])').prop('checked', false);
        saveForm.find('.radio-group').each(function (i, rbGroup) {
            $(rbGroup).find('input[type=radio]:first').prop('checked', true).change();
        });
        saveForm.find('input[type=checkbox]').each(function (i, cb) {
            $(cb).attr('checked', false);
            $(cb).next('input[type=hidden]').val('false');
        });
        saveForm.find('.selectpicker').each(function (i, select) {
            $(this).selectpicker('val', $(select).find('option:first').val());
            //stylize Selectpicker disabled
            if ($(this).hasClass('disabled')) {
                $(this).next('button').attr('disabled', true);
            }
        });

        if (_validated) {
            _validated.resetForm();
        }

        // removes border-danger class
        let errorElements = saveForm.find('.border-danger');
        errorElements.map(function (e) {
            $(errorElements[e]).removeClass('border-danger');
        });

        // removes text-danger class
        errorElements = saveForm.find('.text-danger:not(i)');
        errorElements.map(function (e) {
            $(errorElements[e]).removeClass('text-danger');
        });

    },
    validate: function (params) {
        let _this = new Object(this);
        //let formUtil = this;
        //params = {
        //    form: "",
        //    custom: {},
        //    dataTable: "",
        //    isTwoSubmit: true,
        //    saveSuccessCallback: function,
        //    preSave(form, modal),
        //   successMessage: ""
        //    ajax: { type, url, data }
        //}

        try {
            let _validatedForm = $(params.form).validate({
                debug: true,
                errorElement: "small",
                errorClass: "border-danger text-danger",
                rules: params.custom.rules,
                ignore: params.custom.ignore,
                messages: params.custom.messages,
                errorPlacement: params.custom.errorPlacement,
                unhighlight: params.custom.unhighlight,
                success: params.custom.success,
                submitHandler: function (form) {
                    form = $(form);

                    params.successMessage === undefined ? params.successMessage = "Success! Record was saved." : params.successMessage = params.successMessage;
                    // params.customValidations should return object { success: boolean, message: string }
                    if (params.customValidations !== undefined && typeof params.customValidations === 'function') {
                        let result = params.customValidations();
                        if (result.hasOwnProperty('error')) {
                            toastrError(result.error)
                            return;
                        } else {
                            ajaxSave();
                        }
                    } else {
                        ajaxSave();
                    }

                    function ajaxSave() {
                        blockUi(form.parents('.modal-content'), 'Saving...');

                        if (params.preSave !== undefined) {
                            params.preSave(form, $(form).parents('.modal.show'));
                        }


                        let _type = $(form).attr('method'),
                            _url = $(form).attr('action'),
                            _data = $(form).serialize();

                        if (params.ajax) {
                            _type = params.ajax.type;
                            _url = params.ajax.url;
                            _data = params.ajax.data;
                        }


                        $.ajax({
                            type: _type,
                            url: _url,
                            data: _data
                        }).done(function (data, textStatus, xhr) {
                            if (data.hasOwnProperty('data')) {

                                //successMessage
                                toastrSuccess(params.successMessage);

                                //successCallBack
                                if (typeof params.saveSuccessCallback == "function") {
                                    params.saveSuccessCallback(form);
                                }

                                if (params.isTwoSubmit) {

                                    let submitType = "";

                                    if (typeof params.submitType === "function") {
                                        submitType = params.submitType();
                                    } else if (typeof params.submitType === "string") {
                                        submitType = params.submitType;
                                    } else {
                                        throw new Error("Submit type parameter is undefined");
                                    }



                                    if (submitType === "done") {
                                        $(form).parents('.modal').find('.modal-header > a.close').trigger('click');
                                    } else {
                                        _this.resetSaveForm($(form), _validatedForm);
                                    }

                                } else {
                                    $(form).parents('.modal.show').find('.modal-header > a.close').trigger('click');
                                }

                                if (params.dataTable) {
                                    if (typeof params.dataTable === "function") {
                                        let datatable = params.dataTable();
                                        datatable.reload();
                                    }
                                    else if (params.dataTable.length == 1 && params.dataTable[0] instanceof HTMLElement) {
                                        $(params.dataTable).KDatatable().reload();
                                    }
                                }



                            } else {
                                if (data.hasOwnProperty('error') || data.hasOwnProperty('message')) {
                                    let errMsg = data.hasOwnProperty('status_code') ? data.status_code.reason : data.message;
                                    swal(
                                        'System Warning',
                                        errMsg,
                                        'warning'
                                    );
                                }
                            }

                        }).fail(function (xhr, textStatus) {
                            swal(
                                'Error!',
                                'Error: ' + textStatus,
                                'error'
                            );
                        }).always(function (data, textStatus, xhr) {
                            unBlockUi(form.parents('.modal-content'));
                        });
                    }
                }
            });

            let modal = params.form.parents('.modal');

            return _validatedForm;
        }
        catch (error) {

            swal(
                'System Warning',
                'Something went wrong',
                'warning'
            );

            throw error;

        }

    },
    fillFormData: function (result, form, dateArray = null, callback) {

        //result = response.data
        let inputTypes = ['text', 'hidden', 'number'];

        //loop that assigns data to input/textarea/dropdowns/checkboxes with same 'name' attr
        // i = key | result = value
        for (let i in result) {

            let el = form.find("[name='" + i + "']");

            if (el !== undefined && el.length !== 0 && result[i] !== "") {

                if (typeof result[i] == "string") result[i] = result[i].trim();

                //radio inputs

                if ($(el).length > 1) {
                    //form.find(`[type=radio][name=${i}][value="${result[i]}"]`)
                    //    .prop('checked', true)
                    //    .change();

                    if ($(el).attr('type') === 'checkbox') {
                        $(el).attr('checked', result[i]).prop('checked', result[i]).change();
                        form.find("[name='" + i + "'][type=hidden]").val(result[i]);
                    } else if ($(el).attr('type') === 'radio') {
                        // Radio here
                        form.find(`[name="${i}"][value="${result[i]}"]`).attr('checked', true).prop('checked', true).change();
                    } else if ($(el).prop('nodeName') === 'SELECT') {
                        //manually change this part for dropdowns to match HTML text
                        if (result[i] !== "") {
                            //SELECT
                            $(el).selectpicker('val', result[i]).change();
                        }
                    } else if (inputTypes.includes($(el).attr('type')) || $(el).prop('nodeName') === 'TEXTAREA') {
                        if (dateArray) {
                            if (dateArray.length > 0 && dateArray.includes(i)) {
                                $(el).val(convertDateMMDDYYYY(result[i]));
                                $(el).datepicker('update');
                            } else {
                                $(el).val(result[i]);
                            }
                        }
                        else {
                            $(el).val(result[i]);
                        }
                    }
                    continue;
                } else if ($(el).attr('type') === 'checkbox') {
                    $(el).attr('checked', result[i]).prop('checked', result[i]).change();
                    form.find("[name='" + i + "'][type=hidden]").val(result[i]);
                }
                //else if ($(el).attr('type') === 'radio') {
                //    $(el).attr('checked', result[i]).change();
                //    form.find("[name='" + i + "'][type=hidden]").val(result[i]);
                //}
                else if ($(el).prop('nodeName') === 'SELECT') {

                    //manually change this part for dropdowns to match HTML text
                    if (result[i] !== "") {
                        //SELECT
                        $(el).selectpicker('val', result[i]).change();
                    }

                }
                else if (inputTypes.includes($(el).attr('type')) || $(el).prop('nodeName') === 'TEXTAREA') {

                    if (dateArray) {
                        if (dateArray.length > 0 && dateArray.includes(i)) {
                            $(el).val(convertDateMMDDYYYY(result[i]));
                            $(el).datepicker('update');
                        } else {
                            $(el).val(result[i]);
                        }
                    }
                    else {

                        $(el).val(result[i]);
                    }

                }
            }



        }

        if (callback !== undefined) {
            callback(result, form);
        }
    },
    updateCheckBoxValue: function (form) {
        form.find('input[type=checkbox]').each(function (i, cb) {
            $(cb).off('change')
                .on('change', function (e) {
                    let n = $(e.currentTarget).attr('name'),
                        v = $(e.currentTarget).prop('checked');
                    form.find('input[type=hidden][name=' + n + ']').val(v);
                    $(this).val(v);
                });

            let n = $(cb).attr('name'),
                v = $(cb).prop('checked');
            form.find('input[type=hidden][name=' + n + ']').val(v);
            $(cb).val(v);

        });
    },
    fixTabindex: function (form) {
        //let tabindex = 1;
        form.find('input,select,button').each(function () {
            if (this.type != "hidden") {
                let $input = $(this);
                $input.attr("tabindex", 1);
                //tabindex++;
            }
        });
    },
    selectTextOnFocus: function (form) {
        form.find('input[type=text], textarea').focus(function (e) {
            $(this).select();
        });
    },
    getFirstInput(form) {
        let listInput = form.find('input[type=text]:visible, select.bootstrap-select:not(:disabled) ~ button:visible, .k-checkbox > span');

        if (listInput.length > 0) {
            return listInput[0];
        } else {
            return null;
        }

    },
    validateElement(validator, strElSelecter = "") {
        if (validator != null && typeof strElSelecter == "string") {
            validator.element(strElSelecter);
        }
    },
    setMultiSelectCorrectOrder(selectElement, clickedIndex, isSelected) {
        let arrSelectedOptions = selectElement.children('option').filter(':selected');
        let arrSelectedOrder = selectElement.prop('arrMultiSelectCorrectOrder') || [];
        let arrSelectedValue = [];
        $.each(arrSelectedOptions, function () {
            arrSelectedValue.push($(this).val());
        });

        // DESELECTED ALL
        if (arrSelectedOptions.length === 0) {
            arrSelectedOrder = [];
        // THERE IS AT LEAST ONE SELECTED
        } else {
            // SELECTED AN OPTION
            if (isSelected === true) {
                for (let a = 0; a < arrSelectedOptions.length; a++) {
                    if ($(arrSelectedOptions[a]).index() === clickedIndex) {
                        arrSelectedOrder.push($(arrSelectedOptions[a]).val());
                        break;
                    }
                }
            // DESELECTED AN OPTION
            } else if (isSelected === false) {
                arrSelectedOrder = arrSelectedOrder.filter(function (item) {
                    return arrSelectedValue.includes(item);
                });
            // SELECTED ALL
            } else {
                arrSelectedOrder = arrSelectedValue;
            }
        }

        selectElement.prop('arrMultiSelectCorrectOrder', arrSelectedOrder);

        return arrSelectedOrder;
    }
};

function SwalYesNo(objOptions, confirmFunction, denyFunction) {
    /*
        @param object objOptions
        @param function confirmFunction()

        objOptions = {
            title: "Confirmation",      // String:
            type: "question",           // String: info, error, warning, question
            text: "question",           // String:
        }

    */

    if (!objOptions.title) objOptions.title = "Confirmation";
    if (!objOptions.title) objOptions.type = "question";
    if (!objOptions.text && !objOptions.html) {
        return new Error('No text was given to SwalYesNo');
    }
    if (typeof confirmFunction != "function" || confirmFunction == undefined) {
        return new Error('No Confirm function was given');
    }

    swal({
        title: objOptions.title,
        text: "",
        html: objOptions.html ? objOptions.html : objOptions.text,
        type: objOptions.type,
        showCancelButton: true,
        confirmButtonText: objOptions.confirmButtonText || "Yes",
        cancelButtonText: objOptions.cancelButtonText || "No",
        reverseButtons: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: true
    })
        .then(function (res) {
            res.value = res.value ? true : false;

            if (res.value) {
                if (typeof confirmFunction == "function") {
                    confirmFunction();
                }
            } else {
                if (typeof denyFunction == "function") {
                    denyFunction();
                }
            }

        });



}

function SwalYes(objOptions, confirmFunction) {


    if (!objOptions.title) objOptions.title = "Notice";
    if (!objOptions.title) objOptions.type = "question";
    if (!objOptions.text && !objOptions.html) {
        return new Error('No text was given to SwalYesNo');
    }
    //if (typeof confirmFunction != "function" || confirmFunction == undefined) {
    //    return new Error('No Confirm function was given');
    //}

    let options = {
        title: objOptions.title,
        text: "",
        html: objOptions.html ? objOptions.html : objOptions.text,
        type: objOptions.type,
        showCancelButton: false,
        confirmButtonText: objOptions.confirmButtonText || "Yes",
        customContainerClass: objOptions.customContainerClass || "",
        reverseButtons: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: true,
    }

    //if (objOptions.hasOwnProperty("customClass") && typeof objOptions.customClass == "object") {
    //    Object.assign(options, {
    //        customClass: objOptions.customClass
    //    });
    //}

    swal(options)
        .then(function (res) {
            if (typeof confirmFunction == "function") {
                confirmFunction();
            }
        });

}

function delayExec(ms = 500) {
    return new Promise(resolve => {
        setTimeout(() => { resolve() }, ms);
    })
}

function swalConfirm(msg, type = "question", title = 'Confirmation') {
    return new Promise((resolve) => {
        swal({
            title: title,
            html: msg,
            type: type,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: true
        }).then(function (result) {
            if (result.value) {
                resolve(true);
            }
            else {
                resolve(false);
            }
        });
    })
}

function swalInfo(msg, type = "info", title = 'Notice') {
    return new Promise((resolve) => {
        swal({
            title: title,
            html: msg,
            type: type,
            showCancelButton: false,
            confirmButtonText: 'Ok',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: true
        }).then(function (result) {
            if (result.value) {
                resolve(true);
            }
            else {
                resolve(false);
            }
        });
    })
}


function swalConfirmYes(msg, type = "question", title = 'Confirmation', confirmButtonText = "Yes") {
    return new Promise((resolve) => {
        swal({
            title: title,
            html: msg,
            type: type,
            showCancelButton: false,
            confirmButtonText: confirmButtonText,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: true
        }).then(function (result) {
            if (result.value) {
                resolve(true);
            }
            else {
                resolve(false);
            }
        });
    })
}


function ApiErrorException(res, container) {
    let errorMsg = S_SOMETHING_WENT_WRONG;
    if (res.hasOwnProperty('Message')) errorMsg = res.Message;
    if (res.hasOwnProperty('error')) errorMsg = res.error + "</br>Please contact MIS/IT.";
    if (res.hasOwnProperty('message')) errorMsg = res.message;
    if (res.hasOwnProperty('error_description')) errorMsg = res.error_description + "</br>Please contact MIS/IT.";
    if (res.hasOwnProperty('status_code') && res.status_code !== null) errorMsg = res.status_code.reason;

    if (container) {
        unBlockUi(container);
    }

    toastrError(errorMsg);
}

function popOverUpdate() {
    let shownPopover = $(".popover");

    if (shownPopover.length > 0) {
        shownPopover = shownPopover[0];
        let b = shownPopover.getBoundingClientRect();
        if (b.bottom > $(window).height()) {
            $('.popover').popover('update');
        }

    }

}

function FocusOnLastRowOnModalHide(params) {

    if (!params.hasOwnProperty("onLastCell")) {
        params.onLastCell = false;
    }

    let stored = {
        lastRow: null,
        lastRowIndex: null,
        lastCell: null,
        lastCellIndex: null,
        distinctProp: null
    }

    //params = {
    //    datatable: null,
    //    modal: null,
    //    //function that returns a distinct value to compare with last savedRow
    //    getDistinctProperty(row) {
    //    }
    //}

    $(params.datatable).on("click", "tbody", e => {

        if (params.onLastCell == true) {

            if ($(e.target).parents('td:first').length > 0) {
                let cell = $(e.target).parents('td:first');
                let row = cell.parents('tr:first');

                stored.lastCell = cell;
                stored.lastCellIndex = cell.index();
                stored.lastRow = row;
                stored.lastRowIndex = row.attr("data-row") || row.index();

                if (params.hasOwnProperty("getDistinctProperty")) {
                    if (!$(row).is('.k-datatable__row-subtable')) {
                        stored.distinctProp = params.getDistinctProperty(row);
                    }

                }
            }
            else {
                stored.lastRow = null;
                stored.lastRowIndex = null;
                stored.lastCell = null;
                stored.lastCellIndex = null;
            }

        }
        else {
            if ($(e.target).parents('tr:first').length > 0) {
                let row = $(e.target).parents('tr:first');
                stored.lastRow = row;
                stored.lastRowIndex = row.attr("data-row") || row.index();

                if (params.hasOwnProperty("getDistinctProperty")) {
                    if (!$(row).is('.k-datatable__row-subtable')) {
                        stored.distinctProp = params.getDistinctProperty(row);
                    }
                }
            }
            else {
                stored.lastRow = null;
                stored.lastRowIndex = null;
            }
        }


    });

    $('.modal').on("hidden.bs.modal", e => {
        let openedModals = $(".modal.show");
        setTimeout(() => { focusOnLastRow(openedModals); }, 300);
    });

    //TODO: Detect datatable update
    if ($(params.datatable).KDatatable()) {
        $(params.datatable).KDatatable().on("k-datatable--on-layout-rendered", e => {
            let openedModals = $(".modal.show");
            focusOnLastRow(openedModals);
        });
    }

    function focusOnLastRow(openedModals) {

        if (params.onLastCell == true) {


            // == exit if null last index
            if (stored.lastRowIndex == null || stored.lastRow == null || stored.lastCell == null) {
                return;
            }

            if ($(params.modal) && openedModals.length > 0) {
                //Check if modal is last in open modals
                if ($(params.modal).is(openedModals[openedModals.length - 1])) {
                    //check if nag-eexist pa si last stored row
                    if (stored.lastRow.is(":visible")) {
                        stored.lastCell.focus();
                    }
                    else {
                        getLastRowAndFocus();
                    }
                }
            }
            else {
                if (stored.lastRow.is(":visible")) {
                    stored.lastCell.trigger("focus");
                } else {
                    getLastRowAndFocus();
                }
            }


        }
        else {

            // == exit if null last index
            if (stored.lastRowIndex == null || stored.lastRow == null) {
                return;
            }


            if ($(params.modal) && openedModals.length > 0) {
                //Check if modal is last in open modals
                if ($(params.modal).is(openedModals[openedModals.length - 1])) {
                    //check if nag-eexist pa si last stored row
                    if (stored.lastRow.is(":visible")) {
                        stored.lastRow.focus();
                    }
                    else {
                        getLastRowAndFocus();
                    }
                }
            }
            else {
                if (stored.lastRow.is(":visible")) {
                    stored.lastRow.trigger("focus");
                } else {
                    getLastRowAndFocus();
                }
            }
        }

    }

    function getLastRowAndFocus() {
        if (params.onLastCell == true) {

            let suspectedRow = params.datatable.find(`tbody tr[data-row='${stored.lastRowIndex}']`);

            // === get distinct property of both rows to see if last row is still in updated datatable
            if (suspectedRow.length == 1 &&
                params.hasOwnProperty("getDistinctProperty") && stored.distinctProp &&
                params.getDistinctProperty(suspectedRow) === stored.distinctProp) {
                //focus on stored cell index of suspected row
                suspectedRow.children(`td:nth-child(${stored.lastCellIndex + 1})`).trigger("focus");
            }

        }
        else {

            // === get selected row based on index
            let suspectedRow = params.datatable.find(`tbody tr[data-row='${stored.lastRowIndex}']`), suspectedRowProp = null;

            // === get distinct property of both rows to see if last row is still in updated datatable

            //if (suspectedRow.length == 1 && params.hasOwnProperty("getDistinctProperty")) {
            //    try {
            //        suspectedRowProp = params.getDistinctProperty(suspectedRow)
            //    }
            //    catch (err) {
            //        return;
            //    }

            //    if (suspectedRowProp === stored.distinctProp) {
            //        suspectedRow.trigger("focus");
            //    }

            //}

            if (suspectedRow.length == 1 &&
                params.hasOwnProperty("getDistinctProperty") &&
                params.getDistinctProperty(suspectedRow) === stored.distinctProp) {
                suspectedRow.trigger("focus");
            }

        }

    }

}


function preventBlurEventIfSameLastValue($inputs) {

    for (let input of $inputs) {

        let rememberValue = function () {
            let lastValue;

            $(input).on('focus', e => {
                lastValue = $(e.currentTarget).val();
            });

            $(input).on('blur', e => {
                if ($(e.currentTarget).val() == lastValue) {
                    e.stopImmediatePropagation();
                }
            });

        }();

    }

}

function truncateLongText(data) {
    return (data.length > 35) ? '<div class="pull-right text-truncate" cursor="pointer" data-toggle="tooltip" title ="' + data + '">' + data + '</div>' : data;
}

function truncateText(data, length) {
    return (data.length > length) ? '<span class="text-truncate-v1 " cursor="pointer" data-toggle="tooltip" title ="' + data + '">' + data + '</span>' : data;
}

function getDecimal(nFloat) {
    return nFloat - Math.floor(nFloat);
}

function PasswordToggler(formGroup) {
    let checkBox = $("<input type='checkbox'/>");
    checkBox.css('display', 'none');
    checkBox.addClass('password_checkbox');
    formGroup.prepend(checkBox);

    formGroup.find('.password_toggler:first').find('.hide').css('display', '');
    formGroup.find('.password_toggler:first').on('click', e => {
        checkBox.click();
    });
    checkBox.on('change', e => {
        let isToggled = $(e.currentTarget).prop('checked');
        if (isToggled) {
            formGroup.find('.password_input').attr('type', 'text');
        }
        else {
            formGroup.find('.password_input').attr('type', 'password');
        }
    })

    formGroup.find('.password_input').parent()
        .on('focus mouseenter', function (e) {
            formGroup.find('.password_input').parent().addClass("visible");
        })
        .on('mouseleave', function (e) {
            formGroup.find('.password_input').parent().removeClass("visible");
        });

}

function inputExceeded(el) {
    var s = $('<span>' + el.val() + '</span>');
    s.css({
        position: 'absolute',
        left: -9999,
        top: -9999,
        // ensure that the span has same font properties as the element
        'font-family': el.css('font-family'),
        'font-size': el.css('font-size'),
        'font-weight': el.css('font-weight'),
        'font-style': el.css('font-style')
    });
    $('body').append(s);
    var result = s.width() > el.width();
    //remove the newly created span
    s.remove();
    return result;
}

function MemberTypeToolTip(element = $(), arrMemberType = [], apiCallBack = null) {

    if (arrMemberType != null && arrMemberType.length > 0)  {
        
        makeTooltip(element, arrMemberType);
    }
    else {
        blockUi(element, 'Loading member types...');
        $.getJSON(
            urlSetter.replace('Action', 'membertypes').replace('Controller', 'search').replace('Area', 'framework'), {
            classorder: ""
        },
            function (response) {
                if (response.hasOwnProperty('data')) {
                    if (response.data.length === 0) {
                        //
                    } else {
                        makeTooltip(element, response.data)
                    }


                    if (typeof apiCallBack == "function") {
                        apiCallBack(response.data);
                    }

                } else {
                    // Something went wrong. Please try again.
                }

            }
        ).always(function () {



            unBlockUi(element);
        });
    }
   

    function makeTooltip(element, arrData) {
        let htmlTooltip = function () {
            let sHtml = '';

            //sHtml += `<div style="max-height: 150px;" data-scroll="true">`;

            for (let i = 0; i < arrData.length; i++) {
                sHtml += `<li class="text-left">${arrData[i].membertype.trim() + ' - ' + arrData[i].description.trim()}</li>`;
            }

            //sHtml += `</div>`;

            return sHtml;
        };

        element.attr('data-original-title', htmlTooltip());
        element.attr('data-html', 'true');
        element.tooltip();
    }
}

$.fn.CustomPopOver = function (params) {

    let selector = $(this);


    let defaults = {
        container: "body",
        minWidth: 250,
        maxHeight: 0,
        header: "",
        spinner: false,
    }

    //set defaults
    setDefaults();

    params.content = function () {

        let maxHeight = function () {
            if (params.maxHeight != 0 && typeof params.maxHeight == 'number') {
                return `max-height: ${params.maxHeight}px!important;`
            }
        }

        return `<div class="popover-inner-body" style='min-width: ${params.minWidth}px!important; ${maxHeight()}'></div>`;
    }

    selector.attr('data-html', true);
    //selector.attr('data-trigger', 'click');
    //selector.attr('data-container', params.container);
    selector.attr('data-content', params.content());

    selector.off('shown.bs.popover').on('shown.bs.popover', e => {

        e.stopImmediatePropagation();

        if (params.header != "") {
            $('.popover-header').html(
                `<div class="k-head position-relative p-0" style="min-height: unset;">
                                    <h6 class="k-head__title custom__k-head-title my-0" style="font-size: unset;">${params.header}</h6>
                                </div>`);
        }

        if (params.spinner) {
            $('.popover-body .popover-inner-body').html(`<div class="py-3"><div class="spinner-border spinner-border-sm k-font-brand mx-auto d-block" role="status"> <span class="sr-only">Loading...</span> </div></div>`);
        }

        if (typeof params.onShownEvent == "function") {
            params.onShownEvent($('.popover-body'), $('.popover-body .popover-inner-body'), $('.popover-header'));
        }
    })
    selector.on('hidden.bs.popover', e => {
        if (typeof params.onHiddenEvent == "function") {
            params.onHiddenEvent();
        }
    });

    selector.on('click', e => {

        let init = async function () {

            if (typeof params.onClickEvent == 'function') {
                await params.onClickEvent(e);
            }

            if (typeof params.validateShow == 'function') {

                let isShow = await params.validateShow(e);

                if (isShow == false) {
                    return;
                }
                else {
                    $(e.currentTarget).popover('show');
                }
            }
            else {
                $(e.currentTarget).popover('show');
            }

            //$(e.currentTarget).popover('show');

        }();
    });

    function setDefaults() {

        for (let key in defaults) {
            if (!params.hasOwnProperty(key)) {
                params[key] = defaults[key]
            }
        }

    }

}

